import styled from 'styled-components'

export const StyledIcon = styled.div<{
  actionable?: boolean
  width?: string
  color?: string
}>`
  ${(props) => props.width ? 'width: ' + props.width + ';' : ''};
  display: inline-block;
  display: flex;
  color: ${(props) => props.color || 'inherit'};
  cursor: ${(props) => (props.actionable ? 'pointer' : 'inherit')};
`
